import type { OnInit} from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'ppl-dashboard-item',
    templateUrl: './dashboard-item.component.html',
    styleUrls: ['./dashboard-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardItemComponent implements OnInit {
  @Input() icon: string;
  @Input() name: string;
  @Input() link: string;
  @Input() target = '_self';

  constructor() { }

  ngOnInit() {
  }

}
